import React from "react"
import { UserConsumer } from "@context/UserContext"

// Also update in https://github.com/smaller-earth/postcard/blob/main/app/models/concerns/checklistable.rb
const CHECKLIST_NO_LOCK = [
  "participant_agreements",
  "documents",
  "flight",
  "insurance",
  "events",
  "payments",
  "police_check",
  "work_permits",
  "visa",
  "h_two_b_visa",
  "interviews",
  "courses",
  "referrals",
  "linked_application",
  "community"
]

const withChecklist = (itemName) => (WrappedComponent) => {
  return (props) => (
    <UserConsumer>
      {({ menu: { checklist } = { checklist: [] } }) => {
        const profileStatus = () => {
          try {
            const items = checklist.filter((item) => item.profile_position === "inside")

            // Consider an item complete if it's either marked as complete OR it's locked with 100% completion
            const isItemComplete = (item) =>
              item.status === "complete" || (item.status === "locked" && item.percentage === 100)

            if (
              items
                .filter((item) => !CHECKLIST_NO_LOCK.includes(item.system_name))
                .every((item) => item.status === "locked" && item.percentage !== 100)
            )
              return "locked"
            else if (items.every((item) => item.status === "incomplete")) return "incomplete"
            else if (items.every(isItemComplete)) return "complete"
            else return "started"
          } catch {
            return "incomplete"
          }
        }

        return <WrappedComponent {...props} checklist={checklist} profileStatus={profileStatus()} />
      }}
    </UserConsumer>
  )
}

export default withChecklist
